<div class="flex-column gap pb-3">
    <app-service-settings-common
        [hideShareWithOtherServicesInput]="true"
        [defaultData]="store.operationalSettings()"
        [title]="'service.operationalReport.settings.header'"
    >
        <ng-template #additionalContent>
            <p-divider></p-divider>
            <app-check-input [form]="ssForm" id="useLocation"
                label="service.operationalReport.settings.useLocation"
            ></app-check-input>
            <app-check-input [form]="ssForm" id="useShift"
                label="service.operationalReport.settings.useShift"
            ></app-check-input>

            @if (ssForm.controls.useShift.value) {
                <app-link-button
                    label="service.operationalReport.settings.editShifts"
                    [style]="{ padding: 0 }"
                    (clickEvent)="openShiftsDialog()"
                ></app-link-button>
            }
            <app-check-input [form]="ssForm" id="useForm"
                label="service.operationalReport.settings.useForm"
            ></app-check-input>
        </ng-template>
        <ng-template #footer>
            <app-action-buttons
                [primaryButtonVisibility]="ssForm.enabled"
                (primaryClickEvent)="saveSettings()"
                (secondaryClickEvent)="reset()"
            ></app-action-buttons>
        </ng-template>
    </app-service-settings-common>

    <app-card-table
        #typeTable
        [tableTitle]="'service.operationalReport.fields.type'"
        translatePrefix="service.operationalReport.type."
        [columns]="typeColumns"
        [defaultSorters]="[{ column: 'key', direction: 'ASC' }]"
        [gridData]="$any(store.data.getOperationalReportTypes())"
        [hideCheckboxes]="true"
        [showClearFilter]="false"
        [additionalFilter]="[[{
            column: 'serviceId',
            value: [routeParams.serviceId()],
            operator: 'EQ',
        }]]"
        [refreshCallback]="store.api.getOperationalReportTypes"
        [refreshCallbackFragment]="getOperationalReportTypeFrag"
        (deleteCallbackWithEvent)="deleteType($event)"
        (detailCallback)="upsertType($event)"
        (createCallback)="upsertType()"
    ></app-card-table>
</div>
